import React from "react";
import { Box, Typography, Grid, Chip, Divider, Paper } from "@mui/material";
import { ReceiptLongOutlined, InfoOutlined } from "@mui/icons-material";

const DocumentationFeeItemCard = ({ entityDocumentationFee = null }) => {
  const rawFee = entityDocumentationFee?.documentationFee;
  const feeAmount = rawFee !== undefined && rawFee !== null ? Number(rawFee) : null;
  const isFeeActive = entityDocumentationFee?.isActive !== false && feeAmount !== null && feeAmount > 0;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        border: "1px solid",
        borderColor: isFeeActive ? "#90caf9" : "divider",
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(25, 118, 210, 0.08)"
            : "#f4f8ff",
        borderRadius: 2,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        mb={1.5}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <ReceiptLongOutlined color="primary" fontSize="small" />
          <Typography variant="subtitle2" fontWeight={700} color="primary.main">
            Default Price Item: Documentation & Processing Fee
          </Typography>
        </Box>
        <Chip
          size="small"
          label="One-Time Fee"
          color="primary"
          variant="outlined"
          sx={{ fontWeight: 600, fontSize: "0.75rem" }}
        />
      </Box>

      <Grid container spacing={2} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Price Item
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            Documentation & Processing Fee
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Charge Amount
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            color={isFeeActive ? "primary.dark" : "text.secondary"}
          >
            {feeAmount !== null && feeAmount > 0
              ? `Rs. ${feeAmount.toFixed(2)}`
              : "Rs. 0.00"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Billing Frequency
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Charged once per shipment
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "rgba(25, 118, 210, 0.15)" }} />

      <Box display="flex" alignItems="flex-start" gap={1}>
        <InfoOutlined color="info" sx={{ fontSize: 16, mt: 0.2 }} />
        <Typography variant="caption" color="text.secondary">
          {feeAmount !== null && feeAmount > 0 ? (
            <>
              This standard fee of <strong>Rs. {feeAmount.toFixed(2)}</strong> will be automatically added when you submit the first price for this shipment. It will only be charged once and will not be added again on extra prices.
            </>
          ) : (
            <>
              A standard Documentation & Processing Fee will automatically be included with the first shipment price and charged only once.
            </>
          )}
        </Typography>
      </Box>
    </Paper>
  );
};

export default DocumentationFeeItemCard;
